import { Image, Typography } from "antd";
import { Link } from "wouter";
const { Paragraph, Text } = Typography;
const About = () => {
  return (
    <div className="text-left">
      <Image src="/assets/images/about.png" preview={false} />
      <div className="my-8 px-16 max-sm:px-4">
        <Paragraph>
          <Text>
            Alpshop.in started with a thought to improvise the purchase
            experience of dealers, distributors, and customers across industries
            by providing them with high quality products online, effortlessly.
            The platform is now ready to cater to products in multiple segments
            and categories including spares, wares, consumables, products, and
            services of Automotive, household, marine, construction, sports,
            leisure, building, mass transit, infrastructure, healthcare to name
            a few. This multivendor platform is also ready to customers with
            additional E-commerce savvy customers with the following - Wide
            variety of products across Automotive, AC & Refrigeration, and
            Sports & Leisure categories Rubber products for more than 100+
            vehicles including 2-wheelers, 3-wheelers, Passenger cars, LCV & HCV
            Wide range of insulation products including Thermal, Acoustics
            sheets & tubes, Tapes & Accessories. More than 650+ products already
            listed & targeting growth of 50,000 products a month
          </Text>
        </Paragraph>
        <Paragraph>
          <Text>
            Our offer It is the best platform for Wholesale & Retail Trading of
            Spare Parts online on India catering to Automotive Replacement, Air
            conditioning, Refrigeration Thermal and Acoustic insulation, and
            Sports and Leisure & Flooring solutions across India. Easy &
            convenient ordering Easily browseable MRP catalogue Regular deals
            and discounts Cashback on orders Clearance sales Low Minimum Order
            Quantities Quick Doorstep Deliveries Access to Detailed and Updated
            Price Catalogue Customer friendly return and refund policies
          </Text>
        </Paragraph>
        <Paragraph>
          <Text>
            <Link to="alpshop.in">Alpshop.in</Link> is proudly based on the
            philosophy of Atmanirbhar Bharat and focusing on contributing
            towards the same. We are determined to grow with our partners in the
            E-commerce domain and provide best quality products and services to
            our customers with much ease
          </Text>
        </Paragraph>
      </div>
    </div>
  );
};

export default About;
